import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { RuneLogo } from "@/components/RuneLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — sign in with your new password.");
      navigate("/login", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not reset your password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center px-4">
      <div className="relative w-full max-w-md rounded-2xl border border-[color:var(--rb-border)] bg-[color:var(--rb-obsidian)] p-8">
        <div className="flex items-center gap-3">
          <RuneLogo className="h-9 w-9" />
          <h1 className="rb-display text-xl font-semibold text-[color:var(--rb-text)]">Reset your password</h1>
        </div>
        {token ? (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (8+ chars)" data-testid="reset-password-input"
              className="h-11 border-[color:var(--rb-border)] bg-[color:var(--rb-code)] text-[color:var(--rb-text)]" />
            <Button type="submit" disabled={busy} data-testid="reset-submit-button"
              className="h-11 w-full rounded-xl bg-[color:var(--rb-accent)] text-[color:var(--rb-void)] hover:bg-[color:var(--rb-accent-2)]">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Set new password"}
            </Button>
          </form>
        ) : (
          <p className="mt-6 text-sm text-[color:var(--rb-text-dim)]">
            This reset link is missing its token. <Link to="/login" className="text-[color:var(--rb-accent)] hover:underline">Back to sign in</Link>.
          </p>
        )}
      </div>
    </div>
  );
}
